import { Link } from "react-router-dom";

const SOCIAL_LINKS = [
  {
    label: "TikTok",
    href: "https://www.tiktok.com/@afaaq_wetaan",
    icon: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.75a4.85 4.85 0 01-1.01-.06z" />
      </svg>
    ),
  },
  {
    label: "X",
    href: "https://x.com/wetaan_co",
    icon: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.736-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/afaaq_wetaan",
    icon: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/showcase/afaaq-wetaan/",
    icon: (
      <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
];

const PROGRAMS = [
  {
    label: "مسار الذكاء الاصطناعي",
    href: "https://store.afaaqwetaan.com/%D8%A7%D9%84%D8%B0%D9%83%D8%A7%D8%A1-%D8%A7%D9%84%D8%A7%D8%B5%D8%B7%D9%86%D8%A7%D8%B9%D9%8A/c114156635",
  },
  {
    label: "مسار الأمن السيبراني",
    href: "https://store.afaaqwetaan.com/%D8%A7%D9%84%D8%A3%D9%85%D9%86-%D8%A7%D9%84%D8%B3%D9%8A%D8%A8%D8%B1%D8%A7%D9%86%D9%8A/c887145818",
  },
  {
    label: "المعسكرات التدريبية",
    href: "https://store.afaaqwetaan.com/-/c114156635",
  },
  { label: "الدورات المسجّلة", href: "https://store.afaaqwetaan.com/gZjAXqN" },
  {
    label: "باقة مواطن القوة",
    href: "https://store.afaaqwetaan.com/%D8%AA%D9%88%D8%A7%D8%B2%D9%86/c1832887726",
  },
  {
    label: "الورش التفاعلية",
    href: "https://store.afaaqwetaan.com/%D9%88%D8%B1%D8%B4-%D8%B9%D9%85%D9%84/c1978495418",
  },
];

const QUICK_LINKS = [
  { label: "البرامج", href: "#programs" },
  { label: "مشاريع الخريجين", href: "#proof" },
  { label: "تجارب المتدربين", href: "#testimonials" },
  { label: "المتجر", href: "#store" },
  { label: "الأسئلة الشائعة", href: "#faq" },
];

function ColTitle({ children }) {
  return (
    <p className="font-mono text-[.58rem] tracking-[.16em] uppercase text-mint font-bold mb-[1.1rem] flex items-center gap-1.5 before:content-['◆'] before:text-[.38rem] before:opacity-60">
      {children}
    </p>
  );
}

function FooterLinks({ links }) {
  return (
    <ul className="flex flex-col gap-2 list-none">
      {links.map(({ label, href }) => (
        <li key={label}>
          <a
            href={href}
            target={href.startsWith("http") ? "_blank" : undefined}
            rel={href.startsWith("http") ? "noopener" : undefined}
            className="text-[.82rem] text-t-dim no-underline transition-all duration-200 hover:text-mint hover:pr-1 flex items-center gap-1.5 group"
          >
            <span className="text-[.7rem] opacity-0 transition-opacity duration-200 group-hover:opacity-100 flex-shrink-0">
              ›
            </span>
            {label}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default function Footer() {
  return (
    <>
      {/* ── Pre-footer strip ── */}
      <div className="relative overflow-hidden bg-ink border-t border-[rgba(109,211,167,.08)] border-b border-b-[rgba(109,211,167,.06)] px-[clamp(16px,5vw,80px)] py-[clamp(18px,3vh,28px)] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 flex-wrap">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse 60% 100% at 50% 50%,rgba(109,211,167,0.03) 0%,transparent 70%)",
          }}
        />
        <p
          className="text-t-sec relative z-[1]"
          style={{ fontSize: "clamp(.88rem,.95rem,1rem)" }}
        >
          <strong className="font-cairo font-bold text-t-primary">
            آفاق توصلك للآفاق
          </strong>{" "}
          — ابدأ رحلتك اليوم أو انضم للمجتمع مجاناً.
        </p>
        <div className="flex gap-2.5 flex-wrap flex-shrink-0 relative z-[1] w-full sm:w-auto">
          <a
            href="https://store.afaaqwetaan.com"
            target="_blank"
            rel="noopener"
            className="flex-1 sm:flex-none text-center font-cairo font-bold text-[.88rem] bg-mint text-ink px-[22px] py-2.5 rounded-[4px] no-underline whitespace-nowrap transition-all duration-200 hover:opacity-90 hover:-translate-y-px"
          >
            استعرض البرامج
          </a>
          <a
            href="https://www.instagram.com/afaaq_wetaan"
            target="_blank"
            rel="noopener"
            className="flex-1 sm:flex-none text-center font-cairo font-medium text-[.86rem] border border-[rgba(247,242,233,.16)] text-t-sec px-[18px] py-2.5 rounded-[4px] no-underline whitespace-nowrap transition-all duration-200 hover:border-[rgba(247,242,233,.35)] hover:text-t-primary"
          >
            انضم للمجتمع
          </a>
        </div>
      </div>

      {/* ── Main footer ── */}
      <footer className="relative overflow-hidden bg-[#040E18] px-[clamp(16px,5vw,80px)] pt-[clamp(40px,7vh,80px)] pb-0">
        {/* horizon line */}
        <div
          className="absolute bottom-[80px] left-0 right-0 h-px pointer-events-none"
          style={{
            background:
              "linear-gradient(90deg,transparent,rgba(109,211,167,0.08) 25%,rgba(242,185,73,0.1) 50%,rgba(109,211,167,0.08) 75%,transparent)",
          }}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.8fr_1fr_1fr_1fr] gap-x-[clamp(20px,4vw,56px)] gap-y-[clamp(32px,5vh,48px)] mb-[clamp(40px,5vh,60px)]">
          {/* ── Brand ── */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="/" className="flex items-center gap-2 no-underline mb-4">
              <span className="text-[1.1rem] text-mint">◆</span>
              <span className="font-cairo text-[1.25rem] font-bold text-t-primary tracking-tight">
                آفاق
              </span>
              <span className="w-px h-4 bg-t-dim mx-1" />
              <span className="text-[.62rem] text-t-sec font-normal">وتان</span>
            </a>
            <p
              className="font-cairo font-bold text-mint mb-[.6rem] leading-[1.3]"
              style={{ fontSize: "clamp(.9rem,1vw,1.05rem)" }}
            >
              آفاق توصلك للآفاق.
            </p>
            <p className="text-[.8rem] text-t-dim leading-[1.75] mb-[1.4rem] max-w-[480px]">
              البرنامج التدريبي التقني لمؤسسة وتان لتقنية المعلومات. رحلة مكثفة
              تساعدك تبني خبرتك الحقيقية وتجربة ثرية مع مجتمع متكامل يشبهك.
            </p>

            {/* Social icons — each with its own real link */}
            <div className="flex gap-2.5 flex-wrap">
              {SOCIAL_LINKS.map(({ label, href, icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-[8px] bg-[rgba(109,211,167,.06)] border border-[rgba(109,211,167,.12)] flex items-center justify-center no-underline text-t-sec transition-all duration-200 hover:bg-[rgba(109,211,167,.14)] hover:border-[rgba(109,211,167,.3)] hover:text-mint hover:-translate-y-0.5"
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* ── Programs ── */}
          <div>
            <ColTitle>البرامج</ColTitle>
            <FooterLinks links={PROGRAMS} />
          </div>

          {/* ── Quick links ── */}
          <div>
            <ColTitle>روابط سريعة</ColTitle>
            <FooterLinks links={QUICK_LINKS} />
          </div>

          {/* ── Contact ── */}
          <div className="sm:col-span-2 lg:col-span-1">
            <ColTitle>تواصل معنا</ColTitle>

            {[
              {
                icon: "✉",
                label: "البريد الإلكتروني",
                value: (
                  <a
                    href="mailto:afaaq@wetaan.com"
                    className="text-t-sec hover:text-mint transition-colors no-underline"
                  >
                    afaaq@wetaan.com
                  </a>
                ),
              },
              {
                icon: "📞",
                label: "الجوال",
                value: (
                  <a
                    href="tel:+966553266203"
                    className="text-t-sec hover:text-mint transition-colors no-underline font-mono tracking-wide"
                    dir="ltr"
                  >
                    +966 55 326 6203
                  </a>
                ),
              },
              {
                icon: "🕐",
                label: "ساعات العمل",
                value: "الأحد–الخميس · ٩ص – ٥م",
              },
              {
                icon: "📍",
                label: "المقر",
                value: "الدمام، المملكة العربية السعودية · أونلاين",
              },
            ].map(({ icon, label, value }) => (
              <div key={label} className="flex items-start gap-2.5 mb-[.85rem]">
                <div className="w-7 h-7 rounded-[8px] bg-[rgba(109,211,167,.06)] border border-[rgba(109,211,167,.1)] flex items-center justify-center flex-shrink-0 text-[.7rem]">
                  {icon}
                </div>
                <div className="text-[.78rem] text-t-dim leading-[1.5]">
                  <span className="font-mono text-[.48rem] tracking-[.1em] uppercase text-t-dim block mb-0.5">
                    {label}
                  </span>
                  {value}
                </div>
              </div>
            ))}

            {/* Store badge */}
            <a
              href="https://store.afaaqwetaan.com"
              target="_blank"
              rel="noopener"
              className="flex items-center gap-2.5 bg-[rgba(109,211,167,.05)] border border-[rgba(109,211,167,.12)] rounded-[8px] px-3.5 py-2.5 mb-[.8rem] no-underline transition-all duration-200 hover:bg-[rgba(109,211,167,.1)] hover:border-[rgba(109,211,167,.25)]"
            >
              <span className="text-[1.1rem] flex-shrink-0">🛒</span>
              <div>
                <span className="font-mono text-[.46rem] tracking-[.1em] uppercase text-t-dim block mb-px">
                  POWERED BY SALLA
                </span>
                <span className="text-[.78rem] font-semibold text-t-sec">
                  store.afaaqwetaan.com
                </span>
              </div>
            </a>

            <div className="flex items-center gap-1.5 font-mono text-[.68rem] text-t-dim">
              <span className="text-[.38rem] text-gold">◆</span>
              دفع بالتقسيط متاح عبر تمارا
            </div>
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div className="border-t border-[rgba(109,211,167,.07)] py-[clamp(16px,2.5vh,24px)] flex flex-col sm:flex-row items-center justify-between gap-3 flex-wrap text-center sm:text-right">
          <p className="font-mono text-[.56rem] text-t-dim tracking-[.06em]">
            © ٢٠٢٦ <span className="text-mint">آفاق</span> — وتان لتقنية
            المعلومات · جميع الحقوق محفوظة
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            {["سياسة الخصوصية", "شروط الاستخدام", "سياسة الاسترداد"].map(
              (link) => (
                <a
                  key={link}
                  href="#"
                  className="font-mono text-[.56rem] tracking-[.06em] text-t-dim no-underline transition-colors duration-200 hover:text-t-sec"
                >
                  {link}
                </a>
              ),
            )}
          </div>
          <div className="font-mono text-[.52rem] text-t-dim tracking-[.06em] flex items-center gap-1.5">
            <span className="text-[.38rem] text-mint">◆</span>
            AFQ · آفاق توصلك للآفاق
          </div>
        </div>
      </footer>
    </>
  );
}
